import React from "react";

const certificatePreview = "/img/NABL-Certificate-NABLC0626MH04748.png";
const scopePdf = "/img/NABL-Scope-NABLC0626MH04748.pdf";

const Certificates = () => {
  return (
    <main className="bg-white py-8 lg:py-12">
      <div className="mx-auto w-[95%] max-w-6xl">
        <header className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-gray-900 lg:text-4xl">
            NABL Accreditation
          </h1>
          <p className="mt-3 text-base text-gray-600">
            Certificate NABLC0626MH04748 | Valid from 06/06/2026 to
            05/06/2030
          </p>
        </header>

        <section aria-labelledby="certificate-heading">
          <h2
            id="certificate-heading"
            className="mb-5 text-center text-2xl font-semibold text-gray-900"
          >
            Certificate of Accreditation
          </h2>

          <div className="mx-auto w-full max-w-3xl">
            <img
              src={certificatePreview}
              alt="NABL Certificate of Accreditation NABLC0626MH04748 for Recon Calibration and Test Labs LLP"
              className="h-auto w-full rounded-sm border border-gray-200 object-contain shadow-sm"
            />
          </div>
        </section>

        <section className="mt-12" aria-labelledby="scope-heading">
          <div className="mb-5 text-center">
            <h2
              id="scope-heading"
              className="text-2xl font-semibold text-gray-900"
            >
              Scope of Accreditation
            </h2>
            <p className="mt-1 text-sm text-gray-600">71-page annexure</p>
          </div>

          <iframe
            src={scopePdf + "#view=Fit&toolbar=0&navpanes=0"}
            title="NABL scope of accreditation NABLC0626MH04748"
            className="mx-auto aspect-[210/297] w-full max-w-3xl rounded-sm border border-gray-200 bg-gray-50 shadow-sm"
          />
        </section>
      </div>
    </main>
  );
};

export default Certificates;
